import React, { useState } from 'react';
import { formatDate } from '../../utils/formatters';
import { numericRegex, dollarAmountRegex, isBlank, updateRequiredField} from '../../utils/dailyPaymentFormHelpers';
import { isSuccessfulResponse } from '../../utils/responseHelpers';
import { makeStyles } from '@material-ui/core/styles';
import { LoanService } from '../../services';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
import { useNotification } from '../../contexts/NotificationContext';
import { useError } from '../../contexts/ErrorContext';

const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'absolute',
    left: "30%",
    top: "15%",
    width: '40vw',
    height: '50vh',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: 'scroll',
  },
  modalButton: {
    marginLeft: '15px',
    marginTop: '15px',
    float: 'right',
  },
  coreForm: {
    height: '50vh'
  }
}));

const NewFundingRequest = (props) => {
  const classes = useStyles();
  const [loanNumber, setLoanNumber] = useState(null);
  const [loanNumberError, setLoanNumberError] = useState(false);
  const [amount, setAmount] = useState(null);
  const [amountError, setAmountError] = useState(false);
  const { createErrorNotification } = useNotification();
  const { showError } = useError();
    
  const resetState = () => {
    setLoanNumber(null);
    setAmount(null);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    updateRequiredField(loanNumber, setLoanNumber, setLoanNumberError);
    updateRequiredField(amount, setAmount, setAmountError);
    if (loanNumberError || isBlank(loanNumber)) {
        createErrorNotification("Invalid loan number. Must be in format '12345'");
    } else if (amountError || isBlank(amount)) {
        createErrorNotification("Invalid Amount. Must be in format '123' or '123.45'");
    } else {
      await LoanService.newFundingRequest({
        loanNumber: ('PP' + loanNumber),
        amount: amount, // sent in dollars
        fundingDate: formatDate(props.selectedDate),
      }).then(response => {
        if (isSuccessfulResponse(response)) {
          resetState();
          props.toggleShowNewFundingRequest();

          // TODO: Improve me
          setTimeout(() => window.location.reload(), 500);
        } else {
          createErrorNotification("Failed to save new funding request");
        }
      }).catch(showError);
    }
  }

  const handleCancel = () => {
    props.toggleShowNewFundingRequest();
    resetState();
  }

  const handleLoanNumberChange = (event) => {
    if (numericRegex.test(event.target.value)) {
      setLoanNumberError(false);
      setLoanNumber(event.target.value);
    } else {
      setLoanNumberError(true);
    }
  }


  const handleAmountChange = (event) => {
    if (dollarAmountRegex.test(event.target.value)) {
      setAmountError(false);
      setAmount(event.target.value);
    } else {
      setAmountError(true);
    }
  }

  const body = (
    <div className={classes.paper}>
      <h2 id="simple-modal-title">Create Funding Request</h2>
      <form onSubmit={handleSubmit}>
        <TextField label="Loan Number" inputProps={{ maxLength: 10 }} InputProps={{startAdornment: <InputAdornment position="start">PP</InputAdornment>,}} autoFocus={true} required={true} error={loanNumberError} onChange={handleLoanNumberChange} />
        <TextField label="Amount" inputProps={{ maxLength: 9 }} InputProps={{startAdornment: <InputAdornment position="start">$</InputAdornment>,}} fullWidth={true} margin="normal" required={true} error={amountError} onChange={handleAmountChange} />
        <Grid container spacing={5} justifyContent="flex-start">
          <Grid item xs={12}>
            <Button variant="contained" color="primary" className={classes.modalButton} onClick={handleSubmit}>Create</Button>
            <Button variant="contained" className={classes.modalButton} onClick={handleCancel}>Cancel</Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );

  return (
    <div>
      <Modal
        open={props.showNewFundingRequest}
        onClose={props.toggleShowNewFundingRequest}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}

export default NewFundingRequest;